function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#e3a5f2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:2px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 18,
  height: 18,
  rx: 2
}), /*#__PURE__*/React.createElement("circle", {
  className: "a",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(4 4)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M16,5,11,0,0,11",
  transform: "translate(2 7)"
}));

var SvgColumns = function SvgColumns(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.414,
    height: 20.414,
    viewBox: "0 0 20.414 20.414",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgColumns, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/columns.187a2452.svg";
export { ForwardRef as ReactComponent };